module.exports = __webpack_public_path__ + "static/Q3Answer5_Eggs_JakubKapusnak-689c04819bda6bc217dd965a4c331b0b.jpg";